export default __webpack_public_path__ + "static/card-8-a8730990041ce8e8e6d80222b86a413b.svg";